/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const createManageOrganizationPageStyles = makeStyles(theme => ({
  root: {
    position: 'relative',
  },
  h3: {
    color: theme.palette.primary.main,
    margin: '0 0 30px',
  },
  wrapperBreadcrumbs: {
    marginBottom: '24px',
  },
  mainRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    overflow: 'hidden',
    position: 'relative',
    width: '100%',
    height: '100%',
    minHeight: 0,
    '&::after': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: '140px',
      width: '1px',
      height: '100%',
      backgroundColor: 'rgba(0,0,0,0.12)',
      zIndex: 2,
      pointerEvents: 'none',
    },
  },
  verticalTabs: {
    height: '100%',
    width: '100%',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    '& .MuiTabs-scroller': {
      height: '100%',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflow: 'hidden',
    },
    '& .MuiTabs-flexContainer': {
      height: '100%',
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      overflowY: 'auto',
      overflowX: 'hidden',
      '&::-webkit-scrollbar': {
        width: 6,
      },
      '&::-webkit-scrollbar-track': {
        background: 'transparent',
      },
      '&::-webkit-scrollbar-thumb': {
        background: 'rgba(0, 0, 0, 0.2)',
        borderRadius: 3,
        '&:hover': {
          background: 'rgba(0, 0, 0, 0.3)',
        },
      },
    },
    '& .MuiTab-root': {
      minHeight: 48,
      justifyContent: 'center',
      alignItems: 'center',
      padding: '12px 24px',
      textTransform: 'none',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      transition: 'all 0.2s ease-in-out',
      '& .MuiSvgIcon-root': {
        marginRight: 0,
        marginBottom: 1,
        transition: 'transform 0.2s ease-in-out',
      },
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        '& .MuiSvgIcon-root': {
          transform: 'scale(1.1)',
        },
      },
      '&.Mui-selected': {
        backgroundColor: theme.palette.tertiary.main,
        color: '#fff',
        '& .MuiSvgIcon-root': {
          color: '#fff',
          transform: 'scale(1.1)',
        },
      },
    },
    '& .MuiTabs-indicator': {
      display: 'none',
    },
  },
  tabMenu: {
    width: '140px',
    minWidth: '140px',
    maxWidth: '140px',
    height: '100%',
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
  },
  content: {
    flex: 1,
    paddingLeft: theme.spacing(4),
    paddingRight: theme.spacing(4),
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1),
    overflow: 'auto',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    minHeight: 0,
    '&::-webkit-scrollbar': {
      width: 8,
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'rgba(0, 0, 0, 0.2)',
      borderRadius: 4,
      '&:hover': {
        background: 'rgba(0, 0, 0, 0.3)',
      },
    },
  },
  createButton: {
    textTransform: 'none',
    padding: '6px 4px',
    fontSize: '14px',
  },
  formButtons: {
    padding: '20px 0',
    position: 'sticky',
    background: 'rgba(255,255,255,0.8)',
    bottom: '0',
    display: 'flex',
    margin: '0 -7px',
  },
  formButtonWrap: {
    padding: '0 7px',
  },
  bottomDeleteRow: {
    position: 'sticky',
    bottom: '0',
    margin: '0 -40px',
    padding: '20px 20px 32px',
    borderTop: '1px solid #EEEEEE',
    backgroundColor: '#ffffff',
    display: 'flex',
    alignItems: 'center',
    marginTop: '24px',
  },
  bottomDeleteLabel: {
    margin: '0 48px 0 8px',
  },
  bottomDeleteIcon: {
    fontSize: '20px',
  },
  clusterModalText: {
    padding: '20px 20px 10px',
    textAlign: 'center',
  },
  clusterCreateButtons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    paddingTop: '15px',
  },
}));
